import Layout1 from '@/layout/Layout1'

export default [{
  path: '/',
  component: Layout1,
  children: [{
    path: 'home',
    component: () => import('@/components/Home')
  }]
}]
